
import { defineComponent } from '@vue/composition-api'
import { setCurrentLanguage, setLanguageOfBrowser } from '@/plugins/translations/translation'
import { UserProfile } from '@/types/users'

export default defineComponent({
  name: 'LanguageController',
  data: () => ({
    isDropdownToggled: false
  }),
  computed: {
    userProfile (): UserProfile|null {
      return this.$store.direct.state.user.profile
    }
  },
  watch: {
    userProfile: {
      immediate: true,
      handler () {
        this.updateTranslation()
      }
    }
  },
  methods: {
    updateTranslation () {
      if (this.userProfile !== null && this.userProfile.locale !== undefined) {
        setCurrentLanguage(this.userProfile.locale)
      } else {
        setLanguageOfBrowser()
      }
    }
  },
  render: () => null as any
})
